//COMMON
import 'intersection-observer';
import './common';


//SASS - COMMON
import '../sass/main.scss';

const headerHolder = document.querySelector('.header-holder');
const navbar = document.getElementById('navbar');
const mobileButton = document.getElementById('mobileButton');
const html = document.querySelector('html')
var sticky = navbar.offsetTop;

function stickyNav() {
  if (window.pageYOffset >= sticky) {
    headerHolder.classList.add("sticky")
  } else {
    headerHolder.classList.remove("sticky");
  }
} 

window.onscroll = function() {stickyNav()};

if(mobileButton) {
    mobileButton.addEventListener('click', function(e) {
        if(navbar.classList.contains('active')) {
            navbar.classList.remove('active');
            mobileButton.classList.remove('active');
            html.classList.remove('overflow-hidden');
        } else {
            navbar.classList.add('active');
            mobileButton.classList.add('active');
            html.classList.add('overflow-hidden');
        }
    })
}



const videos = document.querySelectorAll('.video');

if(videos) {
    videos.forEach(el => {
        const button = document.querySelector('.play-video');
        const img = document.querySelector('.mask');
        const iframe = document.querySelector('iframe');
        const video = document.querySelector('video');

        button.addEventListener('click', function() {
            img.style.display = "none";
            button.style.display = "none";

            if(iframe) {
                iframe.src += "?autoplay=1";
            }

            if(video) {
                video.play();
            }
        })

        img.addEventListener('click', function() {
            img.style.display = "none";
            button.style.display = "none";

            if(iframe) {
                iframe.src += "?autoplay=1";
            }

            if(video) {
                video.play();
            }
        })

        
    });
}


const dropInput = document.querySelectorAll("[drop-input]");

if (dropInput) {
    dropInput.forEach((el) => {
        const inputElement = el.querySelector("input");
        const dropZoneElement = el.querySelector(".drop-zone");
        const btnRetry = el.querySelector("[data-retry]");

        /*Maximum allowed size in bytes
          5MB Example
          Change first operand(multiplier) for your needs*/
        const maxAllowedSize = 5 * 1024 * 1024;

        dropZoneElement.addEventListener("click", (e) => {
            inputElement.click();
        });

        inputElement.addEventListener("change", (e) => {
            if (inputElement.files.length && inputElement.files[0].size < maxAllowedSize) {
                updateThumbnail(dropZoneElement, inputElement.files[0], el);
            } else {
                alert('Za duży rozmiar pliku')
            }
        });

        dropZoneElement.addEventListener("dragover", (e) => {
            e.preventDefault();
            dropZoneElement.classList.add("drop-zone--over");
        });

        ["dragleave", "dragend"].forEach((type) => {
            dropZoneElement.addEventListener(type, (e) => {
                dropZoneElement.classList.remove("drop-zone--over");
            });
        });

        dropZoneElement.addEventListener("drop", (e) => {
            e.preventDefault();
            if (e.dataTransfer.files.length && e.dataTransfer.files[0].size < maxAllowedSize) {
                inputElement.files = e.dataTransfer.files;
                updateThumbnail(dropZoneElement, e.dataTransfer.files[0], el);
            } else {
                alert('Za duży rozmiar pliku')
            }

            dropZoneElement.classList.remove("drop-zone--over");
        });
        if(btnRetry) {
            btnRetry.addEventListener('click', function (e) {
                e.preventDefault();
                inputElement.click();
            })
        }
    });
}



/**
 * Updates the thumbnail on a drop zone element.
 *
 * @param {HTMLElement} dropZoneElement
 * @param {File} file
 */
function updateThumbnail(dropZoneElement, file, divWrapper) {
    const defaultText = divWrapper.querySelector('.drop-zone__default');
    const successText = divWrapper.querySelector('.drop-zone__success');
    let thumbnailElement = dropZoneElement.querySelector(".drop-zone__thumb");
    let thumbnailElementSpan = thumbnailElement.querySelector("span");

    // First time - remove the prompt
    if (dropZoneElement.querySelector(".drop-zone__prompt")) {
        dropZoneElement.querySelector(".drop-zone__prompt").remove();
        thumbnailElement.style.display = 'flex';
    }

    thumbnailElementSpan.innerHTML = file.name;
    //defaultText.style.display = 'none';
    //successText.style.display = 'flex';
}


$(".scroll-link").click(function(e) {
    //e.preventDefault();
    var aid = $(this).attr("href").split('#');
    if(aid.length>1 && document.getElementById(aid[1])){
    //console.log(aid)
        e.preventDefault();
        $('html,body').animate({scrollTop: $('#'+aid[1]).offset().top - 90}, 'slow');
    }
});

if(location.hash!=''){
    $('html,body').animate({scrollTop: $(location.hash).offset().top - 90}, 'slow');
}

const closeButton=document.querySelector('.close');
if(closeButton){
    closeButton.addEventListener('click', (e)=>{
        e.preventDefault();
        document.getElementById('messageContainer').innerHTML='';
    })
}